var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.24219,
    y: 0.875,
    width: 38.25,
    height: 38.25,
    rx: 19.125,
    stroke: "url(#paint0_linear_830_3536)",
    strokeWidth: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0332 13.333L17.6999 26.6663L11.0332 19.9997",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0332 13.333L17.6999 26.6663L11.0332 19.9997",
    stroke: "url(#paint1_linear_830_3536)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_3536",
    x1: 40.3672,
    y1: -0.00000205101,
    x2: -7.23686,
    y2: 13.8343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A677B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_830_3536",
    x1: 31.0332,
    y1: 13.333,
    x2: 9.34269,
    y2: 22.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A677B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBig);
export default __webpack_public_path__ + "static/media/checked-big.ec08676f019ec0a639c927e605be60fb.svg";
export { ForwardRef as ReactComponent };